export const IMAGE_NODE_NAME = 'image';

// Use these constants to avoid hardcoding attribute names in multiple places
export const IMAGE_HTML_ATTRS = {
  DOC_ID: 'data-doc-id',
  BLOB_NAME: 'data-blob-name',
  TEXT_ALIGN: 'data-align',
} as const;
